import r from"./_root.js";var o=r.Uint8Array;export{o as default};
//# sourceMappingURL=_Uint8Array.js.map
